const enUS = {
  // Claim Forms
  'claimForms.title': 'Claim Forms',
  'claimForms.photoTooSmall': 'Photo is too small, min 10kb',
  'claimForms.photoTooLarge': 'Photo is too large, max 5mb',
  'claimForms.videoTooLarge': 'Video is too large, max 10mb',
  'claimForms.maxFilesExceeded': 'Cannot upload more than 50 files',
  'claimForms.fileAlreadyUploaded': 'This file has been uploaded',
  'claimForms.uploadError': 'Something went wrong, reload and try again',
  'claimForms.checkFileType': 'Check your file type',
  'claimForms.allowedFileTypes': 'Only .jpg, .jpeg, .pdf, .png, .mp4, .mov, and .avi file types are allowed',
  'claimForms.error': 'Error',
  'claimForms.saved': 'Saved',
  'claimForms.saveDraft': 'Save Draft',
  'claimForms.save': 'Save',
  'claimForms.select': 'Select ...',
  'claimForms.agreeWith': 'I agree with',
  'claimForms.termsAndConditions': 'Terms & Conditions',
  'claimForms.fieldRequired': '{field} is required',
  'claimForms.viewFile': 'View File',
  'claimForms.uploadFile': 'Upload File',
  'claimForms.changeFile': 'Change File',
  'claimForms.uploading': 'Uploading...',
  'claimForms.reupload': 'Re-upload',
  'claimForms.agree': 'Agree',
  'claimForms.tcStatement1': 'I / We declare that all information provided above is true to the best of my / our knowledge and belief.',
  'claimForms.tcStatement2': 'I / We agree to give full authority to PT. Asuransi Simas Insurtech to examine and survey if necessary.',
  'claimForms.tcStatement3': 'I / We agree that if I / We make false / fraudulent statements related to claims or conceal anything about material facts in any form that results in the Policy being canceled and losing all current and future claim rights.',
  // Create Claim
  'createClaim.title': 'Create Claim',
  'createClaim.success': 'Success',
  'createClaim.error': 'Error',
  'createClaim.uploadPhotoError': 'Error uploading photo',
  'createClaim.getBenefitsError': 'Error getting benefits list',
  'createClaim.validationFailed': 'Validation failed',
  'createClaim.loading': 'Loading...',
  'createClaim.noBenefitsFound': 'Benefits not found',
  'createClaim.next': 'Next'
}

export default enUS
